import React from "react";
import { Outlet } from "react-router-dom";
import { CssBaseline, Box } from "@mui/material";
import AppTheme from "../../themes/sharedThemes";
import SideMenu from "../../components/sidemenu";
import { dataGridCustomizations } from "../../themes/customizations/dataGrid";
import Header from "../../components/header";
import DatepickerGlobalStyles from "../../themes/customizations/datepickerStyles";
import { SidebarProvider } from "@context/sidebar-context";

const xThemeComponents = {
  ...dataGridCustomizations,
};

const Layout = ({ children }: { children?: React.ReactNode }) => {
  return (
    <AppTheme themeComponents={xThemeComponents}>
      <SidebarProvider>
        <CssBaseline enableColorScheme />
        <DatepickerGlobalStyles />
        <Box
          sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
        >
          <Header />
          <Box sx={{ display: "flex", flex: 1 }}>
            <SideMenu />
            {children || <Outlet />}
          </Box>
        </Box>
      </SidebarProvider>
    </AppTheme>
  );
};

export default Layout;
